import "rsuite/dist/rsuite.min.css";

// import "@benrbray/prosemirror-math/style/math.css";
import "katex/dist/katex.min.css";
import "./App.css";

import { BrowserRouter as Router, Routes, Route, Outlet } from "react-router";

import { Helmet } from "react-helmet";

import { EditorView } from "prosemirror-view";

import { BASE_PATH } from "_config/basePath";
import Landing from "components/landing";
import ConfirmEmail from "components/advisor/ConfirmEmail";
import ProtectedRoute from "_utils/hoc/ProtectedRoute";
import React, { useEffect, Suspense, useRef, useState } from "react";

import jwt_decode from "jwt-decode";
import { logout } from "_utils/slices/authSlice";

import { useTranslation } from "react-i18next";
import { useAppDispatch, useAppSelector } from "store";
import { useToaster, Notification } from "rsuite";

const Main = React.lazy(async () => {
    await import("@citeproc-rs/wasm");
    return import("components/main");
});

EditorView.prototype.updateState = function updateState(state) {
    if (!this.docView) return; // This prevents the matchesNode error on hot reloads
    this.updateStateInner(state, this.state.plugins != state.plugins);
};

Object.filter = (obj, predicate) =>
    Object.fromEntries(Object.entries(obj).filter(predicate));

export const AppContext = React.createContext();

const App = () => {
    const dispatch = useAppDispatch();

    const token = useAppSelector((state) => state.auth.token);

    const { t, i18n } = useTranslation();

    const [ws, setWs] = useState(null);

    const [showChat, setShowChat] = useState(false);

    const toaster = useToaster();

    useEffect(() => {
        // For legacy JWT flow, check expiry; for cookie flow, server handles expiry
        if (token && token !== "cookie") {
            try {
                let decoded_token = jwt_decode(token);
                if (decoded_token.exp < Math.floor(Date.now() / 1000))
                    logout(dispatch);
            } catch (error) {
                logout(dispatch);
            }
        }

        if (!localStorage.getItem("language")) {
            const browserLang = navigator.language || navigator.userLanguage;
            const lang = browserLang?.startsWith("fr") ? "fr" : "en";
            i18n.changeLanguage(lang);
            localStorage.setItem("language", lang);
        } else {
            i18n.changeLanguage(localStorage.getItem("language"));
        }
    }, []);

    const sendAnnouncement = (data) => {
        ws.send(
            JSON.stringify({
                command_type: "announce_message",
                data,
            })
        );
    };

    const sendMessage = (data) => {
        ws.send(
            JSON.stringify({
                command_type: "conversation_message",
                data,
            })
        );
    };

    return (
        <AppContext.Provider
            value={{ sendAnnouncement, sendMessage, ws, showChat, setShowChat }}
        >
            <Router basename={BASE_PATH}>
                <Helmet>
                    <title>
                        Thesis.center - La Plateforme Pour Rédiger Rapport,
                        Mémoire ou Thèse
                    </title>
                    <meta
                        name="description"
                        content="Le traitement de texte gratuit dédié à la rédaction des écrits longs. Thesis automatise toutes les tâches désagréables, de la page de garde à la bibliographie."
                    />
                </Helmet>
                <Routes>
                    <Route path="/confirm-email" element={<ConfirmEmail />} />
                    <Route path="*" element={<Landing />} />
                    <Route
                        path="/app/*"
                        element={
                            <ProtectedRoute>
                                <Main />
                            </ProtectedRoute>
                        }
                    />
                </Routes>
            </Router>
        </AppContext.Provider>
    );
};

export default App;
